(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    var slider = bar.querySelector('[data-announcement-slider]');
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    var prevBtn = bar.querySelector('[data-announcement-prev]');
    var nextBtn = bar.querySelector('[data-announcement-next]');

    if (slides.length <= 1) return;

    var speedSec = parseInt(bar.getAttribute('data-autoplay-speed'), 10);
    if (isNaN(speedSec) || speedSec < 0) speedSec = 5;
    var speed = speedSec > 0 ? Math.max(3, speedSec) * 1000 : 0;
    var index = 0;
    var timer = null;

    function goTo(i) {
      slides[index].classList.remove('announcement-bar__slide--active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('announcement-bar__slide--active');
    }

    function next() {
      goTo(index + 1);
      resetTimer();
    }

    function prev() {
      goTo(index - 1);
      resetTimer();
    }

    function resetTimer() {
      if (timer) clearInterval(timer);
      if (speed > 0) timer = setInterval(next, speed);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    resetTimer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Cart page functionality
  document.addEventListener('DOMContentLoaded', function() {
    const cartForm = document.getElementById('cart-form');
    const prescripteurInput = document.querySelector('[data-prescripteur-input]');

    // Load prescripteur from cart note
    if (prescripteurInput) {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          if (cart.note && cart.note.startsWith('Prescripteur: Dr ')) {
            prescripteurInput.value = cart.note.replace('Prescripteur: Dr ', '');
          }
        })
        .catch(err => console.error('Error loading cart:', err));

      // Save prescripteur on change
      prescripteurInput.addEventListener('change', function() {
        const name = this.value.trim();
        const noteValue = name ? 'Prescripteur: Dr ' + name : '';

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteValue })
        }).catch(err => console.error('Error saving prescripteur:', err));
      });
    }

    // Handle quantity changes with AJAX
    document.querySelectorAll('[data-quantity-selector]').forEach(function(selector) {
      const input = selector.querySelector('[data-quantity-input]');
      if (!input) return;

      const cartItem = selector.closest('[data-cart-item]');
      if (!cartItem) return;

      const lineKey = cartItem.dataset.lineKey;

      input.addEventListener('change', function() {
        const quantity = parseInt(this.value, 10) || 0;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: quantity })
        })
        .then(res => res.json())
        .then(() => {
          window.location.reload();
        })
        .catch(err => console.error('Error updating cart:', err));
      });
    });

    // Handle remove buttons
    document.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const lineKey = this.dataset.cartRemove;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        })
        .then(res => res.json())
        .then(() => {
          window.location.reload();
        })
        .catch(err => console.error('Error removing item:', err));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-moments-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var strip = btn.closest('.collection-moments__scroll-wrapper').querySelector('[data-moments-strip]');
        if (!strip) return;
        var item = strip.querySelector('.collection-moments__item');
        var scrollAmount = item ? item.offsetWidth + 16 : 280;
        strip.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    });

    // Hide arrow when strip is fully scrolled
    document.querySelectorAll('[data-moments-strip]').forEach(function (strip) {
      var wrapper = strip.closest('.collection-moments__scroll-wrapper');
      var arrow = wrapper && wrapper.querySelector('[data-moments-next]');
      if (!arrow) return;

      function updateArrow() {
        var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 8;
        arrow.style.opacity = atEnd ? '0.25' : '1';
        arrow.style.pointerEvents = atEnd ? 'none' : 'auto';
      }

      strip.addEventListener('scroll', updateArrow, { passive: true });
      updateArrow();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Read more / Read less toggle for collection description
  document.querySelectorAll('[data-collection-description]').forEach(function(wrapper) {
    var textEl = wrapper.querySelector('[data-description-text]');
    var btn = wrapper.querySelector('[data-read-more]');
    if (!textEl || !btn) return;

    // Check if text is actually truncated (needs read more)
    function checkTruncation() {
      var wasExpanded = textEl.classList.contains('is-expanded');
      // Temporarily remove expanded to measure clamped vs full height
      textEl.classList.remove('is-expanded');
      var needsTruncation = textEl.scrollHeight > textEl.clientHeight + 2;
      if (wasExpanded) textEl.classList.add('is-expanded');
      btn.hidden = !needsTruncation;
    }

    checkTruncation();
    window.addEventListener('resize', checkTruncation);

    btn.addEventListener('click', function() {
      var isExpanded = textEl.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', isExpanded);
      var label = btn.querySelector('[data-read-more-label]');
      if (isExpanded) {
        label.textContent = btn.closest('.collection-hero__description').dataset.readLessLabel || 'Lire moins';
      } else {
        label.textContent = btn.closest('.collection-hero__description').dataset.readMoreLabel || 'Lire plus';
      }
    });
  });

  // Sort dropdown functionality
  document.querySelectorAll('[data-collection-sort]').forEach(select => {
    select.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  });

  // Filter sidebar toggle (mobile)
  document.querySelectorAll('[data-filter-toggle]').forEach(toggle => {
    var sidebar = document.querySelector('[data-filter-sidebar]');
    var overlay = document.querySelector('[data-filter-overlay]');
    var closeBtn = document.querySelector('[data-filter-close]');
    if (!sidebar) return;

    function openFilters() {
      sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
      sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (overlay) overlay.addEventListener('click', closeFilters);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
        closeFilters();
      }
    });
  });

  // Filter form submission (checkbox changes on desktop)
  document.querySelectorAll('[data-filter-form]').forEach(form => {
    form.addEventListener('change', function(e) {
      if (window.innerWidth >= 1024) {
        submitFilters(form);
      }
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      submitFilters(form);
    });
  });

  function submitFilters(form) {
    var formData = new FormData(form);
    var url = new URL(window.location.href);

    // Clear existing filter params
    Array.from(url.searchParams.keys()).forEach(function(key) {
      if (key.startsWith('filter.')) url.searchParams.delete(key);
    });

    // Add active filter values
    for (var pair of formData.entries()) {
      if (pair[0].startsWith('filter.') && pair[1]) {
        url.searchParams.append(pair[0], pair[1]);
      }
    }

    window.location.href = url.toString();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-featured-products]');
    if (!section) return;
    var viewport = section.querySelector('.featured-products__viewport');
    var prevBtn = section.querySelector('[data-featured-products-prev]');
    var nextBtn = section.querySelector('[data-featured-products-next]');
    if (!viewport || !prevBtn || !nextBtn) return;

    function scrollBy(direction) {
      var step = viewport.clientWidth;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (maxScroll <= 0) return;
      var nextScroll = viewport.scrollLeft + (direction === 'next' ? step : -step);
      viewport.scrollTo({ left: Math.max(0, Math.min(nextScroll, maxScroll)), behavior: 'smooth' });
    }
    prevBtn.addEventListener('click', function () { scrollBy('prev'); });
    nextBtn.addEventListener('click', function () { scrollBy('next'); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const drawer = document.querySelector('[data-drawer]');
    if (drawer && drawer.parentNode && drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    const toggle = document.querySelector('[data-menu-toggle]');

    if (toggle && drawer) {
      function openDrawer() {
        toggle.setAttribute('aria-expanded', 'true');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        toggle.setAttribute('aria-expanded', 'false');
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      toggle.addEventListener('click', function() {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });

      const closeBtn = drawer.querySelector('[data-drawer-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          closeDrawer();
          toggle.focus();
        });
      }

      document.addEventListener('click', function(e) {
        if (!drawer.classList.contains('is-open')) return;
        if (!drawer.contains(e.target) && !toggle.contains(e.target)) {
          closeDrawer();
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
          toggle.focus();
        }
      });

      drawer.querySelectorAll('.header__drawer-dropdown').forEach(function(detailsEl) {
        var summary = detailsEl.querySelector('summary');
        if (summary) {
          detailsEl.addEventListener('toggle', function() {
            summary.setAttribute('aria-expanded', detailsEl.open);
          });
        }
      });
    }

    // Mega menu hover with close delay (prevents accidental close when moving to panel)
    document.querySelectorAll('[data-mega-dropdown]').forEach(function(dropdown) {
      var megaMenu = dropdown.querySelector('.header__mega-menu');
      var trigger = dropdown.querySelector('.header__nav-link');
      var closeTimer;

      function openMega() {
        clearTimeout(closeTimer);
        dropdown.classList.add('is-mega-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (megaMenu) megaMenu.setAttribute('aria-hidden', 'false');
      }

      function closeMega() {
        closeTimer = setTimeout(function() {
          dropdown.classList.remove('is-mega-open');
          trigger.setAttribute('aria-expanded', 'false');
          if (megaMenu) megaMenu.setAttribute('aria-hidden', 'true');
        }, 180);
      }

      dropdown.addEventListener('mouseenter', openMega);
      dropdown.addEventListener('mouseleave', closeMega);

      // Keyboard: Enter/Space on trigger toggles
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (dropdown.classList.contains('is-mega-open')) {
            closeMega();
          } else {
            clearTimeout(closeTimer);
            openMega();
          }
        }
        if (e.key === 'Escape') {
          closeMega();
          trigger.focus();
        }
      });

      // Close on outside click
      document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('is-mega-open');
          trigger.setAttribute('aria-expanded', 'false');
          if (megaMenu) megaMenu.setAttribute('aria-hidden', 'true');
        }
      });
    });

    // Header search panel toggle (expandable predictive search)
    const searchToggle = document.querySelector('[data-header-search-toggle]');
    const searchPanel = document.querySelector('[data-header-search-panel]');
    const headerSearchInput = document.getElementById('header-search');

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        const isOpen = searchPanel.hidden === false;
        searchPanel.hidden = isOpen;
        searchToggle.setAttribute('aria-expanded', !isOpen);
        if (!isOpen) {
          if (headerSearchInput) {
            headerSearchInput.value = '';
            headerSearchInput.focus();
          }
        }
      });

      document.addEventListener('click', function(e) {
        if (searchPanel.hidden) return;
        if (!searchPanel.contains(e.target) && !searchToggle.contains(e.target)) {
          searchPanel.hidden = true;
          searchToggle.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !searchPanel.hidden) {
          searchPanel.hidden = true;
          searchToggle.setAttribute('aria-expanded', 'false');
          searchToggle.focus();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-buy"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.landing-buy').forEach(function(buySection) {
      var sectionEl = buySection.closest('[id^="shopify-section-"]');
      if (!sectionEl) return;
      var sectionId = sectionEl.id.replace('shopify-section-', '');

      var jsonEl = document.querySelector('[data-landing-buy-json="' + sectionId + '"]');
      var stringsEl = document.querySelector('[data-landing-buy-strings="' + sectionId + '"]');
      if (!jsonEl) return;

      var product;
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (e) { return; }
      if (!product || !product.variants || !product.variants.length) return;

      var strings = stringsEl ? JSON.parse(stringsEl.textContent || '{}') : {};
      if (!strings.add_to_cart) strings.add_to_cart = 'Ajouter au panier';
      if (!strings.sold_out) strings.sold_out = 'Rupture de stock';

      var form = buySection.querySelector('[data-product-form]');
      var variantIdInput = form ? form.querySelector('[data-variant-id]') : null;
      var priceEl = buySection.querySelector('[data-landing-price]');
      var addBtn = buySection.querySelector('[data-add-to-cart]');

      function getVariantOptions(v) {
        var o = [];
        if (v.options && Array.isArray(v.options)) {
          v.options.forEach(function(opt) { o.push(String(opt).trim()); });
          return o;
        }
        if (v.option1 != null) o.push(String(v.option1).trim());
        if (v.option2 != null) o.push(String(v.option2).trim());
        if (v.option3 != null) o.push(String(v.option3).trim());
        return o;
      }

      function getSelectedOptions() {
        var byPosition = {};
        buySection.querySelectorAll('.landing-buy__pill.is-selected').forEach(function(pill) {
          var pos = parseInt(pill.getAttribute('data-option-position'), 10);
          var val = pill.getAttribute('data-option-value');
          if (!isNaN(pos) && pos >= 1 && val != null) byPosition[pos] = String(val).trim();
        });
        var options = [];
        for (var p = 1; p <= 3; p++) {
          if (byPosition[p] != null) options.push(byPosition[p]);
        }
        return options;
      }

      function getCurrentVariant() {
        if (product.variants.length === 1) return product.variants[0];
        var selected = getSelectedOptions();
        if (!selected.length) return product.variants[0];
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var vopts = getVariantOptions(v);
          if (vopts.length === selected.length && vopts.every(function(opt, idx) {
            return String(opt).trim() === selected[idx];
          })) {
            return v;
          }
        }
        return product.variants[0];
      }

      function formatMoney(cents) {
        if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }

      function updateVariant(variant) {
        if (!variant) return;

        if (variantIdInput) variantIdInput.value = variant.id;

        if (priceEl) {
          var currentPrice = priceEl.querySelector('[data-current-price]');
          var comparePrice = priceEl.querySelector('[data-compare-price]');
          var savingsBadge = priceEl.querySelector('[data-savings-badge]');

          if (currentPrice) {
            currentPrice.textContent = formatMoney(variant.price);
            currentPrice.classList.toggle('landing-buy__price-current--sale', variant.compare_at_price > variant.price);
          }
          if (comparePrice) {
            if (variant.compare_at_price > variant.price) {
              comparePrice.textContent = formatMoney(variant.compare_at_price);
              comparePrice.hidden = false;
            } else {
              comparePrice.hidden = true;
            }
          }
          if (savingsBadge) {
            if (variant.compare_at_price > variant.price) {
              var savings = Math.round((1 - variant.price / variant.compare_at_price) * 100);
              savingsBadge.textContent = '-' + savings + '%';
              savingsBadge.hidden = false;
            } else {
              savingsBadge.hidden = true;
            }
          }
        }

        var isAvailable = variant.available !== false;
        if (addBtn) {
          addBtn.disabled = !isAvailable;
          var btnText = addBtn.querySelector('[data-add-to-cart-text]');
          if (btnText) btnText.textContent = isAvailable ? strings.add_to_cart : strings.sold_out;
        }

        /* Update the product image */
        if (variant.featured_image) {
          var img = buySection.querySelector('.landing-buy__image');
          if (img) {
            img.src = variant.featured_image.src.replace(/(\.\w+)\?/, function(m, ext) {
              return ext + '?';
            });
            img.alt = variant.featured_image.alt || product.title;
          }
        }
      }

      buySection.querySelectorAll('.landing-buy__pill').forEach(function(pill) {
        pill.addEventListener('click', function(evt) {
          evt.preventDefault();
          var wrapper = pill.closest('.landing-buy__option-pills');
          if (!wrapper) return;
          wrapper.querySelectorAll('.landing-buy__pill').forEach(function(p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');

          var optionBlock = wrapper.closest('.landing-buy__option');
          var label = optionBlock ? optionBlock.querySelector('.landing-buy__option-selected') : null;
          if (label) label.textContent = pill.getAttribute('data-option-value');

          updateVariant(getCurrentVariant());
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-landing-header]');
    if (!header) return;

    var scrollThreshold = 10;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          header.classList.toggle('has-scrolled', window.scrollY > scrollThreshold);
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
  /* Mobile tooltip toggle for ingredient info buttons */
  (function() {
    var tooltipBtns = document.querySelectorAll('[data-ingredient-tooltip]');
    if (!tooltipBtns.length) return;

    function closeAllTooltips() {
      document.querySelectorAll('[data-ingredient-tooltip-content].is-visible').forEach(function(t) {
        t.classList.remove('is-visible');
      });
    }

    tooltipBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var tooltip = btn.nextElementSibling;
        if (!tooltip) return;

        var isVisible = tooltip.classList.contains('is-visible');
        closeAllTooltips();

        if (!isVisible) {
          tooltip.classList.add('is-visible');
        }
      });
    });

    document.addEventListener('click', function() {
      closeAllTooltips();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
